export function isMobileRes() {
    return window.innerWidth <= 1023;
}

export function isTablet() {
    const userAgent = navigator.userAgent.toLowerCase();
    return /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent) || isIpadOS();
}

export function isIpadOS() {
    return navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 2 &&
        /MacIntel/.test(navigator.platform);
}

export function isMobileDevice() {
    return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
}

export function isiOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

export function detectBrowser() {
    const userAgent = navigator.userAgent;
    let browser, browser_value = '';

    // Detect browsers
    if (/Android/i.test(userAgent)) {
        browser = 'Android';
        browser_value = 'android';
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
        if (window.navigator.standalone) {
            // iOS standalone mode (like a web app)
            browser = 'iOS Standalone';
            browser_value = 'ios_standalone';
        } else if (userAgent.indexOf('CriOS') != -1) {
            // Chrome on iOS
            browser = 'Chrome (iOS)';
            browser_value = 'chrome_ios';
        } else {
            // Safari on iOS
            browser = 'Safari (iOS)';
            browser_value = 'safari_ios';
        }
    } else if (userAgent.indexOf('Chrome') != -1) {
        // Other platforms using Chrome
        browser = 'Chrome';
        browser_value = 'chrome';
    } else if (userAgent.indexOf('Safari') != -1) {
        // Other platforms using Safari or other browsers
        browser = 'Safari or Other Browser';
        browser_value = 'safari';
    } else {
        browser = 'Other Browser';
        browser_value = 'other';
    }

    // Create the result object
    const result = {
        name: browser,
        value: browser_value,
    };

    return result;
}


export function gaSendEvent(category, action, label) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
        event: 'gaClick',
        eventCategory: category,
        eventAction: action,
        eventLabel: label
    });
}


/** 
 * 
 * @param {string} eventName Nombre del evento
 * @param {object} obj Objeto de parametros opcional
 */
export function GTMEvent(eventName = null, obj = {}) {
    window.dataLayer = window.dataLayer || [];
    if (eventName) {
        obj.event = eventName;
        dataLayer.push(obj);
    }
}

/*
Se asegura que la funcion se ejecute solo 1 vez, y le da un tiempo de 'espera'
*/
export function delayFunction(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

export function titleize(sentence) {
    if (!sentence.split) return sentence;

    var _titleizeWord = function (string) {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    },
        result = [];
    sentence.split(" ").forEach(function (w) {
        result.push(_titleizeWord(w));
    });
    return result.join(" ");
}

export function initials(full_name) {
    const words = full_name.replace(/\s+/g, ' ').trim().split(' ');

    if (words.length === 1) {
        if (words[0] === '') {
            return '';
        }
        return words[0][0].toUpperCase();
    }

    return (words[0][0] + words[1][0]).toUpperCase();
}

export function getDaysBetweenDates(start, end, dayNames = []) {
    if (dayNames.length >= 1) {
        let result = [];
        dayNames.forEach((dayName) => {
            let days = { sun: 0, mon: 1, tue: 2, wed: 3, thu: 4, fri: 5, sat: 6 },
                day = days[dayName.toLowerCase().substr(0, 3)],
                current = new Date(start);
            current.setDate(current.getDate() + (day - current.getDay() + 7) % 7);
            while (current <= end) {
                result.push(new Date(+current));
                current.setDate(current.getDate() + 7);
            }
        });
        return result;
    }
}

export function dateToString(date, format = 'Y-m-d') {
    if (date != null) {
        let str = format;

        str = str.replace('Y', date.getFullYear());
        str = str.replace('m', leftPad(date.getMonth() + 1, 2, '0'));
        str = str.replace('d', leftPad(date.getDate(), 2, '0'));
        str = str.replace('j', date.getDate());

        if (format.indexOf('F') !== -1) {
            str = str.replace('F', date.toLocaleString('en-us', { month: 'long' }));
        } else {
            str = str.replace('M', date.toLocaleString('en-us', { month: 'short' }));
        }

        return str;
    } else {
        return '';
    }
}

export function stringToDate(str, format = 'Y-m-d') {
    switch (format) {
        case 'Y-m-d':
            let arrDate = str.split('-');
            arrDate = arrDate.map(value => parseInt(value, 10));
            return new Date(arrDate[0], arrDate[1] - 1, arrDate[2]);
        default:
            return null;
    }
}

export function isValidEmail(email) {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)
}

export function timestampToDate(str) {
    let arrTimestamp = str.split(' ');
    let arrDate = arrTimestamp[0].split('-');
    let arrTime = arrTimestamp[1].split(':');

    return convertUtcToLocal(new Date(arrDate[0], parseInt(arrDate[1]) - 1, arrDate[2], arrTime[0], arrTime[1], arrTime[2]));
}

export function convertBytesToKBOrMB(bytes) {
    if (typeof bytes !== 'number') {
        throw new Error('Input must be a numeric value.');
    }

    if (bytes < 0) {
        throw new Error('Input must be a non-negative number.');
    }

    const kilobytes = bytes / 1024;
    const megabytes = kilobytes / 1024;

    if (megabytes >= 1) {
        return `${megabytes.toFixed(2)} MB`;
    } else {
        return `${kilobytes.toFixed(2)} KB`;
    }
}

export function today() {
    return stringToDate(TODAY);
}

export function numberDaysByDateRange(dateRange) {
    let timeDiff = dateRange.to.getTime() - dateRange.from.getTime();

    return Math.ceil(timeDiff / (1000 * 3600 * 24));
}

/* correctDateRange
* Dado un dateRange (Ej: {from: Date('2020-08-01'), to: Date('2020-08-12'])} devuelve el dateRange 
* corrigiendolo en caso de ser necesario. Si dateRange es null o el to es menor que mañana devuelve 
*  el dateRange por defecto. Si el to está bien y el from es menor que mañana setea el from como mañana
*/
export function correctDateRange(dateRange = null) {
    let fromDateDefault = today();
    fromDateDefault.setDate(fromDateDefault.getDate() + 1);

    let toDateDefault = new Date(fromDateDefault.getTime());
    //toDateDefault.setMonth(toDateDefault.getMonth() + 2);
    toDateDefault.setDate(toDateDefault.getDate() + 13);

    if (dateRange == null || dateRange.to < fromDateDefault) {
        dateRange = { from: fromDateDefault, to: toDateDefault };
    } else if (dateRange.from < fromDateDefault) {// Si el from es menor que mañana lo seteo como mañana
        dateRange.from = fromDateDefault;
    }


    return dateRange;
}

export function leftPad(value, length, fill) {
    let str = '';

    for (let i = 0; i < length; i++) {
        str += fill;
    }

    str += value;

    return str.slice(-length);

}

export function formatBigNumber(num) {
    num = parseInt(num, 10);

    if (num >= 1000000) {
        return parseFloat((num / 1000000).toFixed(1)) + 'M'; //parseFloat quita el trailing cero
    } else if (num >= 1000) {
        return parseFloat((num / 1000).toFixed(1)) + 'K';
    } else {
        return num;
    }
}

export function formatPrice(num) {
    return '$' + parseInt(Math.round(num)).toLocaleString('en');
}

export function formatPriceWithDecimals(num) {
    const price = (num % 1 > 0) ? num : parseInt(Math.round(num));
    return '$' + price.toLocaleString('en');
}

export function integerToDecimal(num) {
    if (Number.isInteger(num)) return num.toFixed(2);
    return num;
}


export function formatCPM(num) {
    return '$' + num.toFixed(2);
}

export function timeAgo(dateString) {
    const date = convertUtcToLocal(new Date(dateString.replace(/\s/, 'T')));
    const DAY_IN_MS = 86400000; // 24 * 60 * 60 * 1000
    const today = new Date();
    const seconds = Math.round((today - date) / 1000);

    if (seconds < 20) {
        return 'just now';
    }
    else if (seconds < 60) {
        return 'about a minute ago';
    }

    const minutes = Math.round(seconds / 60);
    if (minutes < 60) {
        return `${minutes} minutes ago`;
    }

    const hours = Math.round(minutes / 60);
    if (hours < 23) {
        return `${hours}hrs ago`;
    }

    const isToday = today.toDateString() === date.toDateString();
    if (isToday) {
        return 'Today'
    }

    const yesterday = new Date(today - DAY_IN_MS);
    const isYesterday = yesterday.toDateString() === date.toDateString();
    if (isYesterday) {
        return 'Yesterday'
    }

    const daysDiff = Math.round((today - date) / (1000 * 60 * 60 * 24));
    if (daysDiff < 30) {
        return `${daysDiff} days ago`;
    }

    const monthsDiff = today.getMonth() - date.getMonth() + (12 * (today.getFullYear() - date.getFullYear()));
    if (monthsDiff < 12) {
        return `${monthsDiff} months ago`;
    }

    const yearsDiff = today.getYear() - date.getYear();

    return `${yearsDiff} years ago`;
}

export function formatFileSize(bytes, decimals = 2) {
    if (bytes == 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export function placeCategoryToMapMarkerIcon(placeCategoryId) {
    let iconsByCategoryId = {
        1: 'fast-food.svg',     //Fast Food
        2: 'gas-station.svg',   //Gas Stations
        3: 'bank.svg',          //Banks
        4: 'gym.svg',           //Gyms
        5: 'supermarket.svg',   //Supermarkets
        6: 'restaruant.svg',    //Restaurants
        7: 'pharmacy.svg'       //Pharmacy
    }

    if (iconsByCategoryId.hasOwnProperty(placeCategoryId)) {
        let placeIcon = new google.maps.MarkerImage(
            `${IMG_PATH}ui/map/markers/places/${iconsByCategoryId[parseInt(placeCategoryId)]}`,
            null,
            null,
            null,
            new google.maps.Size(38, 38)
        );

        return placeIcon;
    } else {
        return null;
    }
}

export function copyToClipboard(text) {
    if (!navigator.clipboard) {
        let auxInput = document.body.appendChild(document.createElement("input"));
        auxInput.value = text;
        auxInput.focus();
        auxInput.select();
        document.execCommand('copy');
        auxInput.parentNode.removeChild(auxInput);

        return Promise.resolve();
    } else {
        return navigator.clipboard.writeText(text);
    }
}


export function materialIconCode(type, id) {
    let icons = {
        place_category: {
            1: 'fastfood',       //Fast Food
            2: 'local_gas_station', //Gas Stations
            3: 'account_balance',   //Banks
            4: 'fitness_center',   //Gyms
            5: 'shopping_cart',     //Supermarkets
            6: 'restaurant',   //Restaurants
            7: 'medical_services'     //Pharmacy
        }
    }

    return icons[type][id];
}

export function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return null;
}
export function equalsArrayIgnoreOrder(a, b) {
    if (a.length !== b.length) return false;
    const uniqueValues = new Set([...a, ...b]);
    for (const v of uniqueValues) {
        const aCount = a.filter(e => e === v).length;
        const bCount = b.filter(e => e === v).length;
        if (aCount !== bCount) return false;
    }
    return true;
}

export function getRandomStyleGuideColor() {
    const colors = [
        'red',
        'orange',
        'green',
        'emerald',
        'teal',
        'blue',
        'light-blue',
        'indigo',
        'purple',
        'pink',
    ];

    return colors[Math.floor(Math.random() * (Math.floor(colors.length) + 1))];
}

export function removeClassStartsWith(node, className) {
    [...node.classList].forEach(v => {
        if (v.startsWith(className)) {
            node.classList.remove(v)
        }
    })
}

export function getDeviceOrientation() {
    return document.documentElement.clientWidth > document.documentElement.clientHeight ? 'landscape' : 'portrait';
}

export function sanitizeHtml(str) {
    var temp = document.createElement('div');
    temp.textContent = str;
    return temp.innerHTML;
}

export function convertUtcToLocal(date) {
    const userTimezoneOffset = date.getTimezoneOffset() * 60000;
    return new Date(date.getTime() - userTimezoneOffset);
}

export function getFormattedTimeAMPM(dateTimeString) {
    const dateTime = new Date(dateTimeString.replace(/-/g, '/'));
    if (isNaN(dateTime)) {
        return "Invalid date";
    }

    const hours = dateTime.getHours();
    const minutes = dateTime.getMinutes();
    const amPm = hours >= 12 ? "PM" : "AM";
    const hour12 = (hours % 12) || 12;

    const formattedTime = hour12.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ' ' + amPm;

    return formattedTime;
}

export function registerGaEvents() {
    document.querySelectorAll('.ga-event').forEach(elem => 
        elem.addEventListener('click', (e) => gaSendEvent(elem.dataset.eventCategory, elem.dataset.eventAction, elem.dataset.eventLabel))
    );
}

export function capitalize(string) {
    return string.replace(/(?:^|\s)\S/g, (c) => c.toUpperCase());
}

export function areObjectsEqual(obj1, obj2) {
    if (obj1 === obj2) {
      return true;
    }
  
    if (obj1 === null || obj2 === null || typeof obj1 !== 'object' || typeof obj2 !== 'object') {
      return false;
    }

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
  
    if (keys1.length !== keys2.length) {
      return false;
    }

    for (let key of keys1) {
      if (!keys2.includes(key) || !areObjectsEqual(obj1[key], obj2[key])) {
        return false;
      }
    }
  
    return true;
}